export default __webpack_public_path__ + "static/image-cf702c19af2119a2719ffb3e44f4f2ac.png";